import {
  IconButton,
  IconButtonProps,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@chakra-ui/react';
import { FC } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';

type PopoverProps = Partial<IconButtonProps> & {
  children: React.ReactNode;
  headerText?: string;
};

const PopoverCustom: FC<PopoverProps> = ({ children, headerText, ...rest }) => {
  return (
    <>
      <Popover>
        <PopoverTrigger>
          <IconButton
            icon={<AiOutlineInfoCircle />}
            bgColor="transparent"
            _hover={{ bgColor: 'transparent' }}
            _active={{ bgColor: 'transparent' }}
            _focus={{ bgColor: 'transparent' }}
            h="auto"
            minW="auto"
            p="0"
            {...rest}
            aria-label="popover button"
          />
        </PopoverTrigger>
        <PopoverContent _focus={{ outline: 'none' }}>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>{headerText}</PopoverHeader>
          <PopoverBody>{children}</PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
};

export default PopoverCustom;
